"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageByCode = void 0;
var _carbonForesight = require("./carbonForesight");
var _chinaRefineryOperatingAnalysis = require("./chinaRefineryOperatingAnalysis");
var _euLongTermPower = require("./euLongTermPower");
var _gasForesight = require("./gasForesight");
var _hydrogenPricingAndAnalytics = require("./hydrogenPricingAndAnalytics");
var _liveDisruptionsTrackerImpact = require("./liveDisruptionsTrackerImpact");
var _liveDisruptionsTrackerSupply = require("./liveDisruptionsTrackerSupply");
var _lngForesight = require("./lngForesight");
var _marginAnalytics = require("./marginAnalytics");
var _powerForesight = require("./powerForesight");
var _recyclingSupplyTrackerChemical = require("./recyclingSupplyTrackerChemical");
var _recyclingSupplyTrackerMechanical = require("./recyclingSupplyTrackerMechanical");
var _rPetPricingAndAnalytics = require("./rPetPricingAndAnalytics");
var _shortTermPower = require("./shortTermPower");
var _supplierCarbonFootprints = require("./supplierCarbonFootprints");
var _supplyAndDemandDatabase = require("./supplyAndDemandDatabase");
const messageByCode = exports.messageByCode = {
  ..._gasForesight.gasForesight,
  ..._liveDisruptionsTrackerImpact.liveDisruptionsTrackerImpact,
  ..._liveDisruptionsTrackerSupply.liveDisruptionsTrackerSupply,
  ..._carbonForesight.carbon,
  ..._chinaRefineryOperatingAnalysis.chinaRefineryOperatingAnalysis,
  ..._euLongTermPower.longTermPower,
  ..._marginAnalytics.marginAnalytics,
  ..._hydrogenPricingAndAnalytics.hydrogenPricingAndAnalytics,
  ..._powerForesight.powerForesight,
  ..._lngForesight.lngForesight,
  ..._shortTermPower.shortTermPower,
  ..._recyclingSupplyTrackerChemical.recyclingSupplyTrackerChemical,
  ..._recyclingSupplyTrackerMechanical.recyclingSupplyTrackerMechanical,
  ..._rPetPricingAndAnalytics.rPetPricingAndAnalytics,
  ..._supplierCarbonFootprints.supplierCarbonFootprints,
  ..._supplyAndDemandDatabase.supplyAndDemandDatabase
};